<!--
 * @Author: cryi.liu
 * @Date: 2020-05-07 13:17:48
 * @LastEditTime: 2020-09-11 16:41:32
 * @Description: 试题库
 -->
<template>
  <div v-if="loaded" class="content">
    <filter-panel
      :filter-menu="filterMenu"
      @set-product-list="setProductListHandler"
      @upload-success="questionExcelUploaded"
      @filters-search="filtersSearch"
      @reset-filters="resetFilters"
      @repull-list="repullListHandler" />
    <data-content
      :filter-menu="filterMenu"
      :content-data="contentData"
      @index-change="pageIndexChanged"
      @repull-list="repullListHandler(false)"
      @reset-index-repull-list="resetIndexRepullListHandler" />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import axios from 'axios';
import FilterPanel from './components/FilterPanel.vue';
import DataContent from './components/DataContent.vue';

const breadcrumb = [{ text: '统考中心', href: '/tr/portal/index.jsp' }, { text: '试题库' }];

export default {
  name: 'ExamQuestionLibrary',
  components: {
    FilterPanel,
    DataContent,
  },
  data() {
    return {
      loaded: false,
      filterMenu: {
        years: [],
        groupCodes: [],
        productList: [],
        libraryTypes: [],
        questionTypes: [],
        levels: [],
      },
      contentData: {
        tableData: [],
        total: 0,
        page: {
          index: 1,
          size: 20,
          count: 0,
        },
      },
    };
  },
  computed: {
    ...mapGetters({
      filters: 'libraryStore/filters',
    }),
  },
  methods: {
    ...mapActions({
      setBreadcrumb: 'pageStore/invokeSetBreadcrumb',
      setProcessingShowState: 'pageStore/invokeSetProcessingShowState',
      setYearsFilter: 'libraryStore/invokeSetYearsFilter',
      setGroupsFilter: 'libraryStore/invokeSetGroupsFilter',
      setTypesFilter: 'libraryStore/invokeSetTypesFilter',
    }),
    /**
     * 并发请求此页面首屏展示所有数据
     */
    concurrentRquestThisPageData() {
      const listParams = {
        pageNumber: this.contentData.page.index,
        pageSize: this.contentData.page.size,
      };

      axios
        .all([
          this.$http.examcenter.libraryFilterMenu(),
          this.$http.examcenter.libraryList(listParams),
        ])
        .then(
          axios.spread((filterMenu, contentData) => {
            if (filterMenu.code === '200') {
              this.filterMenu = filterMenu.data;
            }

            if (contentData.code === '200') {
              const { data } = contentData;
              /**
               * 后台如果没数据直接不返回字段
               * 做容错
               */
              if (!data.content) {
                data.content = [];
              }

              if (!data.count) {
                data.count = 0;
              }

              if (!data.pageCount) {
                data.pageCount = 0;
              }

              const tableData = this.contentBracketTransformUnderline(data.content);

              this.contentData.tableData = tableData;
              this.contentData.total = data.count;
              this.contentData.page.index = data.pageIndex;
              this.contentData.page.count = data.pageCount;
            }

            if (filterMenu.code !== '200' || contentData.code !== '200') {
              alert('数据请求失败');
            }

            this.loaded = true;
            this.setProcessingShowState({ show: false });
          }),
        );
    },
    /**
     * 表格分页索引改变
     */
    pageIndexChanged(index) {
      this.contentData.page.index = index;

      this.requestLibraryListAndSetting(false);
    },
    /**
     * 题目表格上传成功
     */
    questionExcelUploaded() {
      this.requestLibraryListAndSetting();
    },
    /**
     * 根据筛选条件搜索题库列表
     */
    filtersSearch() {
      this.requestLibraryListAndSetting();
    },
    /**
     * 重置筛选条件
     */
    resetFilters(echo) {
      this.requestLibraryListAndSetting(echo);
    },
    /**
     * 删除单条或多条题目时重新请求列表
     */
    repullListHandler() {
      this.requestLibraryListAndSetting();
    },
    /**
     * 设置型号简称处理函数
     */
    setProductListHandler(productList) {
      if (productList instanceof Array) {
        this.$set(this.filterMenu, 'productList', productList);
      } else {
        this.$set(this.filterMenu, 'productList', []);
      }
    },
    /**
     * 筛选条件发生改变时充值page.index并请求列表
     */
    resetIndexRepullListHandler() {
      this.contentData.page.index = 1;

      this.requestLibraryListAndSetting();
    },
    /**
     * 请求表格数据并设置到 data
     */
    // eslint-disable-next-line no-unused-vars
    requestLibraryListAndSetting(echo = true) {
      this.requestLibraryList()
        .then((result) => {
          /**
           * 后台如果没数据直接不返回字段
           * 做容错
           */
          if (!result.content) {
            result.content = [];
          }

          if (!result.count) {
            result.count = 0;
          }

          if (!result.pageCount) {
            result.pageCount = 0;
          }

          return result;
        })
        .then((result) => {
          const tableData = this.contentBracketTransformUnderline(result.content);
          this.contentData.tableData = tableData;

          return result;
        })
        .then((result) => {
          this.contentData.total = result.count;

          return result;
        })
        .then((result) => {
          this.contentData.page.index = result.pageIndex;
          this.contentData.page.count = result.pageCount;
        })
        .catch((result) => {
          alert(result.msg);
        });
    },
    /**
     * 请求表格数据
     */
    requestLibraryList() {
      const params = {
        pageNumber: this.contentData.page.index,
        pageSize: this.contentData.page.size,
        content: this.filters.content,
        years: this.filters.years.join(','),
        groupCodes: this.filters.productGroupCodes.join(','),
        productCodes: this.filters.productCodes.join(','),
        libraryTypes: this.filters.types.join(','),
        levels: this.filters.levels.join(','),
        questionTypes: this.filters.questionTypes.join(','),
      };

      return new Promise(async (resolve, reject) => {
        const result = await this.$http.examcenter.libraryList(params);

        if (result.code === '200') {
          resolve(result.data);
        } else {
          reject(result);
        }
      });
    },
    /**
     * 填空题[]转__
     */
    contentBracketTransformUnderline(questions) {
      questions.forEach((question) => {
        if (question.questionType === '填空') {
          const content = question.content.replace(/\[\]/g, '__');

          question.content = content;
        }
      });

      return questions;
    },
  },
  created() {
    this.setBreadcrumb({
      breadcrumb,
    });

    this.setProcessingShowState({ show: true });

    this.concurrentRquestThisPageData();
  },
};
</script>

<style lang="less" scopoed>
.content {
  margin: 10px 20px;
  margin-bottom: 0;
}
</style>
